import { render, staticRenderFns } from "./pin-details-form.component.vue?vue&type=template&id=41b8c07c"
import script from "./pin-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./pin-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b8c07c')) {
      api.createRecord('41b8c07c', component.options)
    } else {
      api.reload('41b8c07c', component.options)
    }
    module.hot.accept("./pin-details-form.component.vue?vue&type=template&id=41b8c07c", function () {
      api.rerender('41b8c07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/detail-forms/pin-details-form/pin-details-form.component.vue"
export default component.exports